import styled from "styled-components";

export const Container = styled.div``;

export const MapPreview = styled.div<{ $isDragging?: boolean }>`
  background: var(--color-neutral-darkness);
  border: 2px solid var(--color-neutral-dark);
  border-radius: 10px;
  cursor: ${props => (props.$isDragging ? "grabbing" : "grab")};
  height: 220px;
  margin-top: 1.5rem;
  overflow: hidden;
  position: relative;
  touch-action: none;
  width: 100%;

  .map-tiles {
    inset: 0;
    position: absolute;
  }

  .map-tiles img {
    height: 256px;
    position: absolute;
    user-select: none;
    width: 256px;
  }

  .map-marker {
    background: var(--color-brand-blue);
    border: 3px solid #fff;
    border-radius: 50%;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);
    cursor: grab;
    height: 28px;
    padding: 0;
    position: absolute;
    transform: translate(-50%, -50%);
    width: 28px;
    z-index: 2;
  }

  .map-marker::after {
    background: rgba(255, 255, 255, 0.75);
    border-radius: 50%;
    content: "";
    height: 8px;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 8px;
  }

  .map-marker:active {
    cursor: grabbing;
  }

  .map-help {
    background: rgba(0, 0, 0, 0.56);
    border-radius: 999px;
    bottom: 0.75rem;
    color: #fff;
    font-family: "Inter", sans-serif;
    font-size: 0.75rem;
    font-weight: 700;
    left: 50%;
    line-height: 1rem;
    max-width: calc(100% - 1.5rem);
    padding: 0.375rem 0.75rem;
    position: absolute;
    text-align: center;
    transform: translateX(-50%);
    z-index: 1;
  }

  .map-placeholder {
    align-items: center;
    color: var(--color-neutral-light);
    display: flex;
    font-family: "Inter", sans-serif;
    font-size: 0.875rem;
    font-weight: 700;
    height: 100%;
    justify-content: center;
    line-height: 1.25rem;
    padding: 1.5rem;
    text-align: center;
  }

  .map-label {
    color: var(--color-neutral-light);
    font-family: "Inter", sans-serif;
    font-size: 0.75rem;
    font-weight: 700;
    margin-top: 0.5rem;
    text-align: center;
  }
`;
